"use client"

import { FeaturedRate } from "@/lib/generated/graphql"
import Link from "next/link"
import { useState } from "react"

type Props = {
  savingsRates: FeaturedRate[]
  termDepositRates: FeaturedRate[]
  mortgageRates: FeaturedRate[]
}

function renderRatesSection(rates: FeaturedRate[], linkHref: string) {
  return (
    <>
      {rates.length ? (
        rates.map((rate, index) => {
          const row = (
            <div
              className={`grid grid-cols-3 p-3 text-sm hover:bg-gray-50 ${
                index % 2 === 0 ? "bg-interest-background-blue" : "bg-white"
              }`}
            >
              <div>{rate.institution}</div>
              <div>{rate.term}</div>
              <div className="text-right">{rate.rate.toFixed(2)}%</div>
            </div>
          )

          return rate.adUrl ? (
            <Link key={index} href={rate.adUrl} className="text-interest-blue block font-bold">
              {row}
            </Link>
          ) : (
            <div key={index}>{row}</div>
          )
        })
      ) : (
        <div className="p-3 text-center text-sm">There are no featured rates</div>
      )}

      <div className="bg-white p-3 text-right">
        <Link href={linkHref} className="text-interest-blue text-[14px] font-bold hover:underline">
          view all rates
        </Link>
      </div>
    </>
  )
}

export default function FeaturedRatesTabs({ savingsRates, termDepositRates, mortgageRates }: Props) {
  const [selected, setSelected] = useState<"savings" | "term" | "mortgage">("mortgage")

  const tabMeta = {
    savings: {
      label: "Savings",
      rates: savingsRates,
      href: "/saving/savings-account",
    },
    term: {
      label: "Term deposits",
      rates: termDepositRates,
      href: "/saving/term-deposits-1-to-9-months",
    },
    mortgage: {
      label: "Mortgages",
      rates: mortgageRates,
      href: "/borrowing/mortgage",
    },
  } as const

  return (
    <div className="bg-white">
      {/* tabs */}
      <div className="flex">
        {(Object.keys(tabMeta) as Array<keyof typeof tabMeta>).map((key, index, arr) => (
          <button
            key={key}
            type="button"
            onClick={() => setSelected(key)}
            className={`flex-1 cursor-pointer px-1 py-2 text-center text-[12px] font-bold ${
              selected === key ? "text-interest-blue bg-white" : "bg-interest-blue text-white"
            } ${index < arr.length - 1 ? "border-r-2 border-white" : ""}`}
          >
            {tabMeta[key].label}
          </button>
        ))}
      </div>

      {/* header row */}
      <div className="grid grid-cols-3 p-3 text-sm font-bold text-black">
        <div>Institution</div>
        <div>{selected === "savings" ? "Type" : "Term"}</div>
        <div className="text-right">Rate</div>
      </div>

      {renderRatesSection(tabMeta[selected].rates, tabMeta[selected].href)}
    </div>
  )
}
